import s from './Count.module.css'

type Props = {
  count: number
}

const Count = ({ count }: Props) => {
  return <span className={s.count}>{count}</span>
}

export default Count
